import React from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router';

import { getMessage } from 'i18n/i18nWrapper';
import * as loginActions from 'actions/loginActions';

import styles from './css/Logout.css';

const Logout = () => {
  const dispatch = useDispatch();

  function logout() {
    dispatch(loginActions.logout());
  }

  return (
    <div className={styles.container}>
      <p className={styles.blurb}>{getMessage('verificationLogout.blurb')}</p>

      <Link
        className={styles.link}
        data-test-id="logout"
        onClick={logout}>
        {getMessage('verificationLogout.link')}
      </Link>

    </div>
  );
};

export default Logout;
